import { render } from "./StackImage.vue?vue&type=template&id=44580666&ts=true"
import script from "./StackImage.vue?vue&type=script&lang=ts"
export * from "./StackImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__